var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKcllcNavbarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 22.6,
    viewBox: "0 0 168 22.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    transform: "translate(-1117.38 -1853.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    d: "M1117.38 1853.4h22.342l-11.148 11.279 11.148 11.279h-22.342z",
    className: "cls-1",
    transform: "translate(0 -.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6646",
    d: "M1153.437 1853.4l-11.157 11.279 11.157 11.279h11.139l-11.176-11.34 11.176-11.218z",
    className: "cls-1",
    transform: "translate(-9.719 -.027)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    transform: "translate(1159.156 1853.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1378"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6647",
    d: "M1201.36 1875.937l-5.379-8.019-3.059 3.478v4.541h-7.022v-22.545h7.021v9.727l7.537-9.727h8.213l-8.31 9.5 8.728 13.044z",
    className: "cls-1",
    transform: "translate(-1185.9 -1853.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6648",
    d: "M1222.98 1864.614c0-6.508 5.052-11.282 11.748-11.282a11.985 11.985 0 0 1 9.3 3.905l-4.37 3.937a5.72 5.72 0 0 0-4.556-2.139 5.214 5.214 0 0 0-5.269 5.579c0 3.441 2.324 5.548 5.207 5.548a6.333 6.333 0 0 0 4.711-2.169l4.339 3.905a11.269 11.269 0 0 1-9.112 4c-6.821.002-11.998-4.775-11.998-11.284z",
    className: "cls-1",
    transform: "translate(-1200.373 -1853.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6649",
    d: "M1263.334 1875.937l9.983-22.545h6.281l-9.983 22.545z",
    className: "cls-1",
    transform: "translate(-1216.123 -1853.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6650",
    d: "M1295.075 1875.937v-22.545h6.957v16.748h10.79v5.8z",
    className: "cls-1",
    transform: "translate(-1228.512 -1853.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6651",
    d: "M1328.086 1875.937v-22.545h6.957v16.748h10.79v5.8z",
    className: "cls-1",
    transform: "translate(-1241.397 -1853.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6652",
    d: "M1358.351 1864.643c0-6.5 5.046-11.269 11.733-11.269a11.972 11.972 0 0 1 9.287 3.9l-4.365 3.932a5.712 5.712 0 0 0-4.551-2.136 5.208 5.208 0 0 0-5.263 5.573c0 3.436 2.322 5.542 5.2 5.542a6.328 6.328 0 0 0 4.706-2.167l4.334 3.9a11.256 11.256 0 0 1-9.1 3.994c-6.811-.001-11.981-4.768-11.981-11.269z",
    className: "cls-1",
    transform: "translate(-1253.21 -1853.349)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKcllcNavbarLogo);
export default __webpack_public_path__ + "static/media/KCLLC_Navbar_Logo.a5e767bbecedd14fe7c6874f8581fe19.svg";
export { ForwardRef as ReactComponent };